export default __webpack_public_path__ + "static/media/ded-tools-asana.ccb07aee.svg";